import { render, staticRenderFns } from "./DefaultSwitch.vue?vue&type=template&id=2f2baa6e"
import script from "./DefaultSwitch.vue?vue&type=script&lang=js"
export * from "./DefaultSwitch.vue?vue&type=script&lang=js"
import style0 from "./DefaultSwitch.vue?vue&type=style&index=0&id=2f2baa6e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports